import { Helmet } from "react-helmet-async"

import IconFactory from "UI/IconFactory"
import { AppStoreLinks } from "Components/StoreLinks"
import { useIntl } from "react-intl"
import { LoginMethods } from "./LoginMethods/LoginMethods"
import { Languages } from "./Languages/Languages"
import { Animation } from "./Animation/Animation"
import * as S from "./Login.styles"

const Login = () => {
  const intl = useIntl()
  return (
    <S.LoginWrap>
      <Helmet>
        <meta
          name="description"
          content="Logga in på Mina Sidor på Brocc.se. Använd BankID för att logga in."
        />
      </Helmet>
      <S.LeftSection>
        <S.HeaderBlock>
          <S.LogoWrap
            aria-label={intl.formatMessage({
              id: "app.mypages.mainNav.logo.arialabel",
              defaultMessage: "Brocc hemsida",
            })}
          >
            <IconFactory name="logo" />
          </S.LogoWrap>
          <Languages />
        </S.HeaderBlock>
        <LoginMethods />
        <S.FooterBlock>
          <AppStoreLinks />
        </S.FooterBlock>
      </S.LeftSection>
      <S.RightSection>
        <Animation />
      </S.RightSection>
    </S.LoginWrap>
  )
}

export default Login
